export const COMPANY_TYPE_VALUE = {
  BP_SEG: 'bpseg',
  BROKER: 'broker',
  CONSULTANCY: 'consultancy',
  COVENANT: 'covenant',
};

export const COMPANY_TYPE_LABEL = {
  BROKER: 'Corretora',
  CONSULTANCY: 'Assessoria',
  COVENANT: 'Convênio',
};
